export const error = [{
alt:"Error 404 - Page Not Found for Das Tuning, a car tuning service.",
desc:"Dead end, but don't let it stop your car tuning journey. Go back for more options."

}]